import { gql } from '@apollo/client';
import { vehicleStockQuery } from 'next-common';

export const vehicleStockBySerialNoQuery = gql`
  ${vehicleStockQuery}
`;

